'use client'

import { Divider, Group, Tooltip, UnstyledButton } from '@mantine/core'
import { useDisclosure, useMediaQuery } from '@mantine/hooks'
import { APP_NAME } from '@partment/types'
import { RiCustomerServiceLine } from '@remixicon/react'
import dynamic from 'next/dynamic'
import { FC, useEffect, useState } from 'react'
import CurrencySelector from '../../utils/CurrencySelector'

const ContactSupportPopup = dynamic(
  () => import('../ContactSupportPopup').then((mod) => mod.ContactSupportPopup),
  {
    ssr: false,
  },
)

// Absolute root-relative paths for the cross-app brand tabs (rendered as raw
// <a>, so no app basePath is applied). co-owner now lives at /co-owner.
const MappEr = {
  Partment: '/co-owner',
  Stays: '/stays',
}
interface BrandHeaderProps {
  activePath?: string
}
export const BrandHeader: FC<BrandHeaderProps> = ({ activePath = '' }) => {
  const navItems = ['Stays', 'Co-owner']
  const [selected, setSelected] = useState(activePath || 'Stays')
  const isMobile = useMediaQuery('(max-width: 768px)')
  const [opened, { open, close }] = useDisclosure()

  // Set active tab based on current pathname
  useEffect(() => {
    const currentPath = window.location.pathname
    if (currentPath.startsWith(MappEr.Stays)) {
      setSelected('Stays')
    } else if (currentPath.startsWith(MappEr.Partment)) {
      setSelected('Co-owner')
    }
  }, [])

  return (
    <header
      style={{
        backgroundColor: '#000',
        color: '#fff',
        padding: '0px 21px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 40,
      }}
    >
      <Group>
        <Group gap={0}>
          {navItems.map((item) => (
            <UnstyledButton
              key={item}
              component='a'
              href={item === 'Co-owner' ? MappEr.Partment : MappEr.Stays}
              onClick={() => setSelected(item)}
              style={{
                color: selected === item ? '#fff' : '#B7BAC0',
                fontSize: 13,
                fontWeight: 500,
                fontFamily: 'Poppins, sans-serif',
                cursor: 'pointer',
                padding: isMobile ? '16px 10px' : '8px 14px',
                minHeight: isMobile ? '44px' : undefined,
                backgroundColor:
                  selected === item ? '#FFFFFF33' : 'transparent',
                borderBottom:
                  selected === item
                    ? '2px solid #ffffffcc'
                    : '2px solid transparent',
                transition: 'color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease',
              }}
            >
              {item}
            </UnstyledButton>
          ))}
        </Group>
      </Group>

      {/* Right: Icons */}
      <Group py='sm' gap={20} visibleFrom='lg'>
        <CurrencySelector />
        <Divider
          orientation='vertical'
          size='sm'
          bg='#fff'
          className='opacity-50'
          my={3}
        />
        <Tooltip label='Contact Support' withArrow>
          <button type='button' aria-label='Contact Support' onClick={open} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
            <RiCustomerServiceLine
              size={15}
              color='#fff'
            />
          </button>
        </Tooltip>
      </Group>
      {opened && (
        <ContactSupportPopup
          opened={opened}
          onClose={close}
          appName={
            selected === 'Co-owner'
              ? APP_NAME['CO-OWNER']
              : APP_NAME.RENTAL_MARKETPLACE
          }
        />
      )}
    </header>
  )
}
